import { useEffect } from "react"

import i18n, { LANGUAGE_STORAGE_KEY, languages } from "@/utils/i18n"

export const useLanguageSync = () => {
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (
        event.key === LANGUAGE_STORAGE_KEY &&
        event.newValue &&
        languages.includes(event.newValue)
      ) {
        void i18n.changeLanguage(event.newValue)
      }
    }

    window.addEventListener("storage", handleStorageChange)
    return () => window.removeEventListener("storage", handleStorageChange)
  }, [])
}
